module.exports = __webpack_public_path__ + "static/img/bg-five-hole.74cad33.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-five-hole.png
// module id = 44
// module chunks = 0